<template>
    <Carousel v-if="products.length > 0" :config="carouselConfig" class="-mx-3">
        <template v-for="item in products" :key="item.id">
            <!-- FIX: class typo + shadow-safe padding -->
            <Slide class="px-3">
                <div class="w-full">
                    <ProductItem :item="item" :productContextQuery="productContextQuery" hideUnavailableMessage />
                </div>
            </Slide>
        </template>
    </Carousel>

    <div v-else class="text-center text-gray-500 py-16">
        {{ $t('No products found.') }}
    </div>
</template>

<script setup>
import { useAsyncRequest } from '@/composables/useAsyncRequest'
import { pickProductContextQuery } from '@/composables/searchQuery'

const route = useRoute()
const productContextQuery = computed(() => pickProductContextQuery(route.query))
const props = defineProps({
    propertyId: {
        type: Number,
        required: false
    },
    locationId: {
        type: Number,
        required: false
    },
    regionId: {
        type: Number,
        required: false
    },
    regionGroupId: {
        type: Number,
        required: false
    },
    productIds: {
        type: Array,
        required: false
    },
    limit: {
        type: Number,
        required: false,
        default: 6
    }
})

const products = ref([])
const { get, loading, error } = useAsyncRequest()

// Responsive carousel configuration
const carouselConfig = {
    itemsToShow: 4,
    wrapAround: true,
    autoplay: 3000,
    snapAlign: 'start',
    breakpoints: {
        1024: {
            itemsToShow: 4
        },
        768: {
            itemsToShow: 3
        },
        0: {
            itemsToShow: 1
        }
    }
}

onMounted(async () => {
    const response = await get('/api/products/featured', {
        filter: {
            property_id: props.propertyId,
            location_id: props.locationId,
            region_id: props.regionId,
            region_group_id: props.regionGroupId,
            product_ids: props.productIds
        },
        limit: 6
    })

    products.value = response?.data ?? []
})
</script>
